import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const ApiService = {
    getUsers: (token) => {
        return axios.get(`${API_URL}/admin/dashboard/users`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    },

    deleteUser: (userId, token) => {
        return axios.delete(`${API_URL}/admin/dashboard/users/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    },

    updateUser: (userId, userData, token) => {
        return axios.put(`${API_URL}/admin/dashboard/users/${userId}`, userData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    },

    getProducts: (token, page = 1) => {
        return axios.get(`${API_URL}/admin/dashboard/products?page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    },

    getOrders: (token, page = 1, search = '', filters = [], orderBy = []) => {
        const filterParams = filters.map(f => `filter[]=${f}`).join('&');
        const orderByParams = orderBy.map(o => `orderBy[]=${o}`).join('&');
        
        return axios.get(`${API_URL}/admin/dashboard/orders?page=${page}&search=${search}&${filterParams}&${orderByParams}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    },
    
    getOrderDetails: (token, orderId) => {
        return axios.get(`${API_URL}/admin/dashboard/orders/${orderId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    },

    getCustomers: (token, page = 1, search = '') => {
        return axios.get(`${API_URL}/admin/dashboard/rcustomers`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: { page, search } // Include search parameter here
        });
    },
    
    getEmployees: (token, page = 1, search = '') => {
        return axios.get(`${API_URL}/admin/dashboard/remployees`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: { page, search } // Include search parameter here
        });
    },
    
    getShippers: (token, page = 1, search = '') => {
        return axios.get(`${API_URL}/admin/dashboard/rshippers`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: { page, search } // Include search parameter here
        });
    },    
    
};

export default ApiService;
